import React from "react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginView from "./components/LoginView";

function AppInner() {
  const { currentUser } = useAuth();
  if (!currentUser) return <LoginView />;
  return <Layout />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
